export default __webpack_public_path__ + "static/media/reschedule.b1129a86.svg";